import React from 'react';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from '@mui/material';

export interface UnsavedChangesDialogProps {
	open: boolean;
	onContinueEditing: () => void;
	onDiscard: () => void;
	onSave: () => void;
}

function UnsavedChangesDialog({ open, onContinueEditing, onDiscard, onSave }: UnsavedChangesDialogProps) {
	return (
		<Dialog open={open} onClose={onContinueEditing} sx={{ '& .MuiPaper-root': { minWidth: 320 } }}>
			<DialogTitle>Unsaved changes</DialogTitle>
			<DialogContent>
				<DialogContentText>Would you like to save your changes before leaving?</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={onDiscard} color="error" sx={{ mr: 'auto' }}>Discard</Button>
				<Button onClick={onContinueEditing}>Keep editing</Button>
				<Button onClick={onSave} variant="contained" autoFocus>Save</Button>
			</DialogActions>
		</Dialog>
	);
}

export default UnsavedChangesDialog;
